module.exports = __webpack_public_path__ + "img/equinsa.755918e6.png";